// Dispatch settings rows (provisional home: Dispatches > Settings). ONE list: a real setting later = flip `live` and add `key` (i18n: dispatch:set.<id>.{name,value,help}).
// live: stored in general_settings (generic /settings/general) · link: renders as a link, not a control · planned: greyed placeholder, no behaviour.
export const SETTINGS_ROWS = [
  { id: 'stale', status: 'live', key: 'dispatch_stale_days', min: 0, max: 365 },
  { id: 'prices', status: 'planned' },
  { id: 'etaGap', status: 'planned' },
  { id: 'numbering', status: 'planned' },
  { id: 'lateTol', status: 'planned' },
  { id: 'ageWarn', status: 'planned' },
  { id: 'who', status: 'planned' },
  { id: 'badge', status: 'planned' },
  { id: 'address', status: 'link', to: '/control-admin/organisation-settings/partners' },
  { id: 'alertLate', status: 'planned', tbd: true },
  { id: 'perfKpi', status: 'planned', tbd: true },
];
// the 'Incomplete' badge (Settings sub-tab + intro) is automatic: shown while any row is still planned, gone by itself when none remains
export const settingsIncomplete = (rows = SETTINGS_ROWS) => rows.some(r => r.status === 'planned');
export const SETTINGS_INCOMPLETE = settingsIncomplete();
